import React from 'react';
import Icon from '../../../components/AppIcon';
import { Field } from './BackgroundFields';
import { VIEWPORT_LIST, isSectionHidden } from '../utils/defaults';

export default function SectionViewportVisibilityFields({
  section,
  viewport = 'desktop',
  onChange,
}) {
  const toggleHidden = (vpId) => {
    const vp = section[vpId] || {};
    onChange({
      ...section,
      [vpId]: { ...vp, hidden: !vp.hidden },
    });
  };

  return (
    <div className="space-y-3 pt-2 border-t border-border">
      <p className="text-xs font-semibold text-foreground flex items-center gap-1.5">
        <Icon name="MonitorSmartphone" size={14} />
        Visibilité par écran
      </p>
      <div className="space-y-2">
        {VIEWPORT_LIST.filter((v) => v.id !== 'desktop').map((vp) => (
          <label
            key={vp.id}
            className="flex items-center gap-2 text-sm cursor-pointer"
          >
            <input
              type="checkbox"
              checked={section?.[vp.id]?.hidden === true}
              onChange={() => toggleHidden(vp.id)}
              className="rounded border-border"
            />
            <span className="text-muted-foreground">
              Masquer toute la section sur {vp.label.toLowerCase()}
            </span>
          </label>
        ))}
      </div>
      {viewport !== 'desktop' && isSectionHidden(section, viewport) ? (
        <p className="text-[11px] text-amber-700 dark:text-amber-400">
          Cette section est masquée sur l&apos;écran actuellement sélectionné dans
          l&apos;éditeur (aperçu en pointillés).
        </p>
      ) : null}
    </div>
  );
}
